import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  targetId: string
  onDismiss: () => void
}

// Ports the prototype's `.nudge` treatment: a pulsing blue ring and a "Start here →"
// flag attached to the first activity card, so a learner who skips the tour still
// gets pointed at where to begin (within the current session — the flag is gone after reload).
const LearnerProductTourNudge: FC<Props> = ({ targetId, onDismiss }) => {
  const [target, setTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const el = document.getElementById(targetId)
    if (!el) return

    setTarget(el)
    el.classList.add('learner-product-tour-nudge')
    el.addEventListener('click', onDismiss)

    return () => {
      el.classList.remove('learner-product-tour-nudge')
      el.removeEventListener('click', onDismiss)
    }
  }, [targetId, onDismiss])

  if (!target) return null

  return createPortal(<span className="learner-product-tour-nudge-flag">Start here →</span>, target)
}

export default LearnerProductTourNudge
